/* =========================================================
   PEBE SHOP — MODO CLARO / OSCURO
   INDEPENDIENTE DEL APPLE SCROLL
   ========================================================= */

(function () {

  "use strict";


  /* =======================================================
     CONFIGURACIÓN
     ======================================================= */

  const STORAGE_KEY = "pebe-theme";

  const html = document.documentElement;


  /* =======================================================
     LEER TEMA
     ======================================================= */

  function getSavedTheme() {

    try {

      return localStorage.getItem(
        STORAGE_KEY
      );

    } catch (error) {

      return null;

    }

  }


  /* =======================================================
     GUARDAR TEMA
     ======================================================= */

  function saveTheme(theme) {

    try {

      localStorage.setItem(
        STORAGE_KEY,
        theme
      );

    } catch (error) {

      // No hacemos nada si localStorage falla

    }

  }


  /* =======================================================
     ACTUALIZAR BOTÓN
     ======================================================= */

  function updateButtons() {

    const isDark =
      html.classList.contains(
        "pebe-dark"
      );


    document
      .querySelectorAll(
        ".pebe-dark-mode-toggle"
      )
      .forEach(function (button) {

        const icon =
          button.querySelector(
            ".pebe-dark-mode-icon"
          );


        if (!icon) return;


        if (isDark) {

          icon.textContent = "☀️";

          button.setAttribute(
            "aria-label",
            "Cambiar a modo claro"
          );

          button.setAttribute(
            "title",
            "Modo claro"
          );

        } else {

          icon.textContent = "🌙";

          button.setAttribute(
            "aria-label",
            "Cambiar a modo oscuro"
          );

          button.setAttribute(
            "title",
            "Modo oscuro"
          );

        }

      });

  }


  /* =======================================================
     APLICAR TEMA
     ======================================================= */

  function applyTheme(theme) {

    const isDark =
      theme === "dark";


    html.classList.toggle(
      "pebe-dark",
      isDark
    );


    updateButtons();

  }


  /* =======================================================
     INICIALIZAR
     ======================================================= */

  function initialize() {

    const savedTheme =
      getSavedTheme();


    if (savedTheme === "dark") {

      applyTheme("dark");

    } else {

      applyTheme("light");

    }

  }


  /* =======================================================
     BOTÓN
     ======================================================= */

  document.addEventListener(
    "click",
    function (event) {

      const button =
        event.target.closest(
          ".pebe-dark-mode-toggle"
        );


      if (!button) return;


      const isDark =
        html.classList.contains(
          "pebe-dark"
        );


      const newTheme =
        isDark
          ? "light"
          : "dark";


      applyTheme(newTheme);

      saveTheme(newTheme);

    }
  );


  /* =======================================================
     SHOPIFY HORIZON
     ======================================================= */

  document.addEventListener(
    "shopify:section:load",
    function () {

      updateButtons();

    }
  );


  /* =======================================================
     EJECUTAR
     ======================================================= */

  if (
    document.readyState === "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      initialize
    );

  } else {

    initialize();

  }

})();